import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01, GREY_01 } from '../../theme/colors'

import { button } from '../../theme/core';



export const Inner = styled.div`
	${props => row({medium:{reverse:props.reverse}})}
	
	${mediaQuery[SIZE.medium]}{
		padding-top: ${unit(8)};
	}

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(2)};
	}
`

export const ContentContainer = styled.div`
	${props => column({medium:{span:5,after:1,reverse:props.reverse}},{direction:props.theme.direction})}
	padding-bottom: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		padding-bottom: 0;
	}
`

export const TextContent = styled.div`

`

export const Heading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(3)};
`

export const Text = styled.div`
	${typeBody02}
	color: ${props => props.theme.foreground};

	p{
		margin-bottom: ${unit(3)};

		&:last-child{
			margin-bottom: 0;
		}
	}
	
	em{
		background-color: ${props => props.theme.highlight};
	}

	a{
		color: ${props => props.theme.foreground};
		transition: opacity 0.3s;

		&:hover{
			opacity: 0.6;
		}
	}
`

export const Label = styled.p`
	${typeLabel01}
	margin-bottom: ${unit(2)};
	color: ${props => props.theme.alternative};
`


export const ImageContainer = styled.div`
	${props => column({medium:{span:6,reverse:props.reverse}},{direction:props.theme.direction})}
	padding-top: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		padding-top: 0;
	}
`

export const ImageInner = styled.div`
	flex: 1;
	position: relative;

	&:before{
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		top: ${margin(SIZE.small,{multiplier:-1})};
		left: ${margin(SIZE.small,{multiplier:-1})};
		background-color: ${props => props.theme.shadow};

		${mediaQuery[SIZE.medium]}{
			top: ${unit(-8)};
			left: auto;
			${props => props.theme.direction === "ltr" && props.reverse === true || props.theme.direction === "rtl" && props.reverse !== true ? `left:` : `right:`} ${margin(SIZE.medium,{multiplier:-1})};
		}

		${mediaQuery[SIZE.large]}{
			top: ${spacer(-2)};
			${props => props.theme.direction === "ltr" && props.reverse === true || props.theme.direction === "rtl" && props.reverse !== true ? `left:` : `right:`} ${margin(SIZE.large,{multiplier:-1})};
		}

		${mediaQuery[SIZE.max]}{
			${props => props.theme.direction === "ltr" && props.reverse === true || props.theme.direction === "rtl" && props.reverse !== true ? `left:` : `right:`} ${margin(SIZE.large,{multiplier:-1})};
		}

	}
`

export const Image = styled.img`
	width: 100%;
	height: auto;
	position: relative;
`

export const PointList = styled.ul`
	margin-top: ${unit(4)};
`

export const PointItem = styled.li`
	display: flex;
	margin-bottom: ${unit(3)};

	&:last-child{
		margin-bottom: 0;
	}
`

export const PointIcon = styled.img`
	width: ${unit(4)};
	height: ${unit(4)};
	margin-right: ${unit(3)};
	flex: 0 0 auto;
`

export const PointText = styled.div`
	color: ${props => props.theme.foreground};
	align-self: center;

	h3{
		${typeHeading04}
		margin-bottom: ${unit(2)};
	}
	
	p{
		${typeBody02}
	}
	
`

